import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import {
  setKeywordsExclude,
  setKeywordsInclude,
} from '../../../state/actions/company-category-editor'
import OptimizationContainer from './optimization-container';
import {addUpstreamFooterSectionsT, createSectionT} from "../../../state/actions/shared/section";

const mapSectionIdsToSection = (ids, sections) => {
  if(!ids){
    return [];
  } else {
    return ids.map((ele) => {
      const section = sections[ele];
      return section;
    });
  }
}

const OptimizationRedux = (props) => {
  const { id } = useParams();
  return (
    <OptimizationContainer
      keywordsExclude={props.entities[id]?.keywordsExclude}
      keywordsInclude={props.entities[id]?.keywordsInclude}
      title={props.entities[id]?.title}
      {...props}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const {entityId:id} = ownProps;
  const entities = state.companyCategories.editor;
  const sections = state.companyCategories.sections;
  const currentCompanyCategory = entities[id];
  const { footerSectionIds, title } = currentCompanyCategory;
  return {
    entities,
    id,
    title,
    footerSections: mapSectionIdsToSection(footerSectionIds, sections)
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { entityId: id } = ownProps;
  return {
    setKeywordsExclude: (keywordsExclude) => dispatch(setKeywordsExclude(keywordsExclude, id)),
    setKeywordsInclude: (keywordsInclude) => dispatch(setKeywordsInclude(keywordsInclude, id)),
    onCreateSection: () => dispatch(createSectionT('company_category', id, false, 'FOOTER')),
    onFooterSearch: (sections) => dispatch(addUpstreamFooterSectionsT('company_category', id, sections)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OptimizationRedux);
